import { ButtonBase, styled } from '@mui/material';

/**
 * The summary as one line of text that opens the panel. Shrinks with the toolbar rather than pushing the
 * date navigation aside; what does not fit is cut off with an ellipsis.
 */
export const SummaryButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'muted'
})<{ muted?: boolean }>(({ theme, muted }) => ({
  ...theme.typography.body2,
  display: 'block',
  minWidth: 0,
  maxWidth: '100%',
  padding: theme.spacing(1, 1.5),
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'left',
  color: muted ? theme.palette.text.secondary : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));

/** The full list in the tooltip, one name per line. */
export const SummaryTooltipList = styled('ul')(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(4)
}));
